import React, { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";

const CREATE_VENUE_MUTATION = gql`
  mutation createVenueMutation(
    $name: String!
    $address: String!
    $lat: Float!
    $long: Float!
    $thumbnail: String!
    $active: Boolean!
  ) {
    createVenue(
      data: {
        name: $name
        address: $address
        lat: $lat
        long: $long
        thumbnail: $thumbnail
        active: $active
      }
    ) {
      _id
      name
      address
      lat
      long
      thumbnail
      active
    }
  }
`;

export default function GalleryForm() {
  const [placeValue, setPlaceValue] = useState("");
  const [placeConfirmed, setPlaceConfirmed] = useState(false);
  const [image, setImage] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const maxNumber = 1;

  const uploadImage = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("file", image);
    data.append("upload_preset", "a7xscswa");
    data.append("cloud_name", "computer-computer");

    fetch("  https://api.cloudinary.com/v1_1/computer-computer/image/upload", {
      method: "post",
      body: data,
    })
      .then((resp) => resp.json())
      .then((data) => {
        setImgUrl(data.secure_url);
        setVenueFormState({
          ...venueFormState,
          thumbnail: imgUrl,
        });
      })
      .catch((err) => console.log(err));
  };

  let { path } = useRouteMatch();
  const [venueFormState, setVenueFormState] = useState({
    name: "",
    address: "",
    thumbnail: "",
    lat: "",
    long: "",
    active: false,
  });

  const [showFormState] = useState({
    name: "",
    time: "",
    thumbnail: "",
    venue: "",
  });

  const [submissionSuccess, setsubmissionSuccess] = useState(false);

  const handleVenueFormSubmission = () => {
    setsubmissionSuccess(true);
    setVenueFormState({
      name: "",
      address: "",
      thumbnail: "",
      lat: "",
      long: "",
      active: false,
    });
  };

  const [createVenue, { loading, error }] = useMutation(CREATE_VENUE_MUTATION, {
    variables: {
      name: venueFormState.name,
      address: venueFormState.address,
      lat: parseFloat(venueFormState.lat),
      thumbnail: venueFormState.thumbnail,
      long: parseFloat(venueFormState.long),
      active: venueFormState.active,
    },
    onCompleted: () => handleVenueFormSubmission(),
  });

  const FormStatus = () => {
    if (loading)
      return (
        <div>
          <p>loading...</p>
        </div>
      );
    if (error) return <p>Submission Error</p>;
    if (submissionSuccess)
      return (
        <div>
          <p>Success!</p>
        </div>
      );
    return <p></p>;
  };

  const confirmPlace = () => {
    console.log(placeValue);
    geocodeByAddress(`${placeValue.label}`)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) =>
        setVenueFormState({
          ...venueFormState,
          address: placeValue.label,
          lat: lat,
          long: lng,
        })
      )
      .then(console.log(venueFormState))
      .then(setPlaceConfirmed(true));
  };
  const resetPlace = () => {
    setVenueFormState({
      ...venueFormState,
      address: "",
      lat: "",
      long: "",
    });
    setPlaceConfirmed(false);
  };

  return (
    <Router>
      <div className="lg:grid lg:grid-cols-12 lg:gap-x-5 pt-12 h-screen overflow-y-auto">
        <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-9">
          <Switch>
            <Route exact path="/portal/venues">
              <form
                action="#"
                className=""
                onSubmit={(e) => {
                  e.preventDefault();
                  createVenue();
                }}
              >
                <div className="shadow sm:rounded-md sm:overflow-hidden">
                  <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
                    <div>
                      <h3 className="text-lg leading-6 font-medium text-gray-900">
                        Gallery Profile
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">
                        Once your application is accepted, this information will
                        be displayed publicly as the gallery profile.
                      </p>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="col-span-3 sm:col-span-2 space-y-6">
                        <div>
                          <div className="mt-1 rounded-md shadow-sm flex">
                            <span className="bg-gray-50 border border-r-0 border-gray-300 rounded-l-md px-3 inline-flex items-center text-gray-500 sm:text-sm">
                              Gallery
                            </span>
                            <input
                              type="text"
                              name="gallery"
                              id="gallery"
                              autoComplete="gallery"
                              className="focus:ring-indigo-500 focus:border-indigo-500 flex-grow block w-full min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300"
                              value={venueFormState.name}
                              onChange={(e) =>
                                setVenueFormState({
                                  ...venueFormState,
                                  name: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>

                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div className="relative px-4">
                    Venue Address
                    <GooglePlacesAutocomplete
                      className="h-10"
                      apiKey={process.env.REACT_APP_GOOGLE_KEY}
                      selectProps={{
                        placeValue,
                        onChange: setPlaceValue,
                      }}
                    />
                    {placeConfirmed ? (
                      <div className="top-6 w-10 h-10 absolute bg-green-500 opacity-25 w-full"></div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <p
                    onClick={confirmPlace}
                    className=" ml-4 bg-indigo-600 border border-transparent rounded-md shadow-sm my-2 py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
                  >
                    set venue location
                  </p>
                  {placeConfirmed ? (
                    <p
                      onClick={resetPlace}
                      className="ml-4 text-indigo-500 border border-current rounded-md shadow-sm my-2 py-2 px-4 inline-flex justify-center text-sm font-medium hover:text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
                    >
                      update venue location
                    </p>
                  ) : (
                    <></>
                  )}

                  <div className="px-4">
                    {imgUrl ? (
                      <></>
                    ) : (
                      <h1 className="">Select an image for your event.</h1>
                    )}
                    <input
                      type="file"
                      onChange={(e) => setImage(e.target.files[0])}
                    ></input>
                    <button onClick={uploadImage}>Upload</button>
                    <img className={`${imgUrl ? "py-4" : ""}`} src={imgUrl} />
                  </div>

                  <div className="px-4 py-4 bg-gray-50 flex justify-between sm:px-6">
                    <FormStatus />
                    <button
                      type="submit"
                      className={`bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${
                        venueFormState.name &&
                        venueFormState.address &&
                        venueFormState.lat &&
                        venueFormState.long &&
                        venueFormState.thumbnail
                          ? "opacity-100 pointer-events-auto"
                          : "opacity-50 pointer-events-none"
                      }`}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </Route>
          </Switch>
        </div>
      </div>
    </Router>
  );
}

// name: venueFormState.name,
//         address: venueFormState.address,
//         lat: parseFloat(venueFormState.lat),
//         thumbnail: showFormState.thumbnail,
//         long: parseFloat(venueFormState.long),
//         active: venueFormState.active,
